<template>
  <div class="join-beta-program-component">
    <section class="hero is-light is-medium">
      <div class="hero-body">
        <div class="container">
          <SectionTitle
            title="Interested in joining our Beta Program?"
            subtitle="If you or your team would like early access, sumit an application and we'll get back to you!"
            backgroundClass="is-light"
          />
          <br />
          <BetaProgramApplication isCardModalActive="false" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionTitle from "@/components/SectionTitle.vue";
import BetaProgramApplication from "@/components/library/BetaProgramApplication.vue";

export default {
  name: "JoinBetaProgramComponent",
  components: {
    SectionTitle,
    BetaProgramApplication
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
